import { Button, Dialog, HStack, Text } from '@chakra-ui/react';
import { ResponsiveModal } from '../../shared'

interface UnsavedChangesDialogProps {
  isOpen: boolean
  isSaving: boolean
  onSave: () => void
  onDiscard: () => void
  onCancel: () => void
}

/** Three-way replacement for the old two-way window.confirm, whose only outcomes were
 *  "leave and lose the edits" or "stay" — there was no path to saving. */
export function UnsavedChangesDialog({
  isOpen, isSaving, onSave, onDiscard, onCancel,
}: UnsavedChangesDialogProps) {
  if (!isOpen) return null
  return (
    <ResponsiveModal isOpen={isOpen} onClose={onCancel} isCentered size="sm">
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content
          borderTopRadius={{ base: 'xl', md: 'md' }}
          pb="env(safe-area-inset-bottom, 0px)">
          <Dialog.Header borderBottomWidth="1px">Unsaved schedule changes</Dialog.Header>
          <Dialog.Body>
            <Text fontSize="sm" color="gray.600">
              You have schedule edits that haven't been saved yet.
            </Text>
          </Dialog.Body>
          <Dialog.Footer borderTopWidth="1px">
            <HStack gap={2} w="full" justify="flex-end" flexWrap="wrap">
              <Button variant="ghost" minH="44px" onClick={onCancel}>Keep editing</Button>
              <Button
                variant="outline" colorPalette="red" minH="44px"
                disabled={isSaving} onClick={onDiscard}>Discard and leave</Button>
              <Button
                colorPalette="brand" minH="44px"
                loading={isSaving} onClick={onSave}>Save and leave</Button>
            </HStack>
          </Dialog.Footer>
        </Dialog.Content>
      </Dialog.Positioner>
    </ResponsiveModal>
  );
}
